//import Menu from "./controls/menu";
//import Toolbar from "./toolbar";
import Workspace from "./workspace";
import config from "../store/sqftConfig";
import TranslatesProvider from "../../../translatesProvider";
import store from "../../../../../store";
//import {setSQFTMenuOpened} from "../../../../../actions/sqftMenuFunctions";
import {setNewLayout} from "../../navigation/menu/countertop/toolMenu/SqftNavLayouts";
import $ from 'jquery';
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../actions/sqftMenuFunctions";
import sqftEventManager from "../store/sqftEventManager";
import {iconGreenPlus32, objectFlipHorizontal, objectFlipVertical} from "../../../assetsSQFT";
import sqftShape from "./shapes/sqftShape";
import {changeSqftFeaturesPopup, updateSQFTCalculations} from "../../../../../actions/sqftFunctions";
import {clearAllMenusEvents} from "./workspace/workspaceEvents";
import {SIDEBAR_LAYOUTS_BUTTONS} from "../../../constants";

export default new function() {
  var
    i,
    _this       = this,
    overlay     = $(".sqft-tutorial-overlay"),
    currentStep = 1,
    resizeTimes = 1,
    maxSteps    = 5,
    stepText    = {
      1: "sqft.tutorial.step1.title",
      2: "sqft.tutorial.step2.title",
      3: "sqft.tutorial.step3.title",
      4: "sqft.tutorial.step4.title",
      5: "sqft.tutorial.step5.title",
      6: "sqft.tutorial.step6.title" // final
    },
    currentLayout =  SIDEBAR_LAYOUTS_BUTTONS.includes(window.currentLayout) ? window.currentLayout : "LNI",
    nodes       = {};

  this.init = function () {
    if (!config.isDevMode() && !window.location.href.includes("showSqftTutorial=false")) {
      config.tutorialIsRunning = true;
      _this.initNodes();
      nodes.text.text(TranslatesProvider.translates[stepText[1]]);
      _this.setSpecificStepRules(1);
      _this.showTimer = setTimeout(function () {
        _this.showTutorial(function () {
          nodes.ring.removeClass("sqft-tutorial-step__ring--scale");
        });
      }, 200);
      _this.setButtonClicks();
      _this.addCursorImages();
    }
  };

  this.initNodes = function () {
    let overlay = $(".sqft-tutorial-overlay");
    nodes       = {
      overlay,
      text: overlay.find("#sqft-tutorial-text"),
      close: overlay.find("#sqft-tutorial-close"),
      buttonNext: overlay.find("#sqft-tutorial-next"),
      ring: overlay.find(".sqft-tutorial-step__ring"),
      buttons: {
        layouts: overlay.find(".sqft-tutorial-step--1 .button"),
        layout: overlay.find(".sqft-tutorial-step--2 .button"),
        resize: overlay.find(".sqft-tutorial-step--3 .button"),
        edge: overlay.find(".sqft-tutorial-step--4 .button"),
        addToQuote: overlay.find(".sqft-tutorial-step--5 .add-to-quote"),
        addToQuote2: overlay.find(".sqft-tutorial-step--5 .button--add-to-quote"),
      },
      tutorialImages: {
        horizontal: null,
        vertical: null,
        edgeImageButton: null
      },
    };

    for (i = 1; i <= maxSteps; i++) {
      nodes["step"+i] = overlay.find(".sqft-tutorial-step--"+i);
    }
  };

  this.setButtonClicks = function () {
    nodes.close.click(_this.exitTutorial);
    nodes.buttonNext.click(_this.showNextStep.bind(_this, false));
    nodes.buttons.layouts.click(_this.showNextStep);
    nodes.buttons.layout.click(_this.showNextStep);
    nodes.buttons.resize.click(_this.resizeLines);
    nodes.buttons.edge.click(_this.edgeClick);
    nodes.buttons.addToQuote.click(this.showFinishStep);
    nodes.buttons.addToQuote2.click(this.showFinishStep);
  };

  this.showFinishStep = function () {
    nodes.text.text(TranslatesProvider.translates[stepText[6]]);
    nodes.buttonNext.hide();
    nodes.ring.hide();
    overlay.find(".sqft-tutorial-step--"+currentStep).hide();
    Workspace.removeAllShapes();
    setTimeout(() => {
      _this.exitTutorial(true);
    }, 1000);
  };

  this.exitTutorial = function (forEver) {
    nodes.overlay.fadeOut("300");
    if (forEver) {
      const shapes = Workspace.getShapes();
      shapes.forEach(shape => {
        if (shape instanceof sqftShape) {
          const shapeLines = shape.getLines();
          shapeLines.forEach(line => {
            line.deleteAttachedItem();
          });
        }
      });
      _this.removeCursorImages();
      config.tutorialIsRunning = false;

      clearAllMenusEvents();
      store.dispatch(setSQFTMenuOpened(""));
      store.dispatch(setSQFTActiveButton("move"));
      config.workspace.menuItemActive = "";

      const reduxState = store.getState();
      const updateCalculations = reduxState.sqftState.updateCalculations;
      store.dispatch(updateSQFTCalculations(updateCalculations + 1));
      store.dispatch(changeSqftFeaturesPopup({visited: true}));
    }
  };

  this.showTutorial = function (callBack) {
    nodes.overlay.fadeIn("300");
    callBack();
  };

  this.showNextStep = function (animationFinished) {
    const nextStep = currentStep + 1;
    if (nextStep > maxSteps) {
      _this.exitTutorial(true);
      return;
    }
    if (nextStep === 3) {
      setNewLayout(currentLayout);
      //store.dispatch(setNewLayout(window.currentLayout || "LNI"));
      //Toolbar.setNewLayout(window.currentLayout || "LNI");
    } else if (nextStep === 4 && !animationFinished) {
      _this.resizeLines();
      return;
    } else if (nextStep === 5 && !animationFinished) {
      _this.edgeClick();
      return;
    }
    nodes.overlay.attr("data-step", nextStep);
    nodes["step"+currentStep].fadeOut(300, function () {
      nodes.text.text(TranslatesProvider.translates[stepText[nextStep]]);
      _this.setSpecificStepRules(nextStep);
      currentStep = nextStep;
    });
  };

  this.setSpecificStepRules = function (nextStep) {
    let highlightElement = null;
    switch (nextStep) {
      case 1: {
        highlightElement = document.querySelector(".sidebar .button--layouts");
        break;
      }
      case 2: {
        //Menu.sideBarButtonClick(document.querySelector(".sidebar .button[data-menu=\"layouts\"]"));
        store.dispatch(setSQFTMenuOpened("layouts"));
        store.dispatch(setSQFTActiveButton("layouts"));
        let timeOut = 300;
        switch (currentLayout) {
          case "S":
          case "SP":
          case "SI":
          case "SPI":
            timeOut = 300;
            break;
          case "SN":
          case "SPN":
            timeOut = 350;
            break;
          case "SNI":
          case "SPNI":
            timeOut = 400;
            break;
          case "L":
          case "LI":
            timeOut = 450;
            break;
          case "LN":
          case "LNI":
            if (window.innerHeight < 480 || window.innerWidth < 991) {
              const $scrollDiv = $('.side.layouts');
              $scrollDiv.stop().animate({ scrollTop: $scrollDiv[0].scrollHeight }, 300);
              timeOut = 800;
            } else {
              timeOut = 600;
            }
            break;
          default:
            break;
        }
        setTimeout(() => {
          highlightElement = document.querySelector(".shapes-list .button[data-layout="+currentLayout+"]");
          nodes["step2"].fadeIn(300);
          const rect = highlightElement.getBoundingClientRect();
          nodes["step" + nextStep].css({
            top: rect.top,
            left: rect.left,
          });
          _this.moveRing(rect);
        }, timeOut);
        break;
      }
      case 3: {
        //Menu.openMenu();
        store.dispatch(setSQFTMenuOpened("move"));
        store.dispatch(setSQFTActiveButton("move"));
        setTimeout(() => {
          highlightElement = document.querySelector(".navigation .button--resize");
          nodes["step3"].fadeIn(300);
          const rect = highlightElement.getBoundingClientRect();
          nodes["step" + nextStep].css({
            top: rect.top,
            left: rect.left,
          });
          _this.moveRing(rect);
        }, 400);
        break;
      }
      case 4: {
        highlightElement = document.querySelector(".navigation .button--edge");
        if (!highlightElement) {
          _this.showNextStep(true);
          return
        }

        nodes["step4"].fadeIn(300);
        break;
      }
      case 5: {
        const selector = window.innerWidth < 991 ? ".sidebar2 .button--add-to-quote" : "[data-id='nav_add_to_quote']";
        highlightElement = document.querySelector(selector);
        nodes.ring.addClass("step5");
        nodes["step5"].fadeIn(300);
        $("#sqft-tutorial-close").hide();
        $("#sqft-tutorial-next")
          .text(TranslatesProvider.translates["sqft.tutorial.buttonFinish"])
          .off()
          .click(_this.showFinishStep);

        const shapes = Workspace.getShapes(); // delete lines button plus
        shapes.forEach(shape => {
          const shapeLines = shape.getLines();
          shapeLines.forEach(line => {
            line.setTutotialImage(null);
          });
        });
        break;
      }
      default:
        break;
    }
    if (highlightElement && nextStep !== 2 && nextStep !== 3) {
      const rect = highlightElement.getBoundingClientRect();
      nodes["step" + nextStep].css({
        top: rect.top,
        left: rect.left,
      });
      _this.moveRing(rect);
    }
  };

  this.moveRing = function (rect) {
    let top = rect.top;
    let left = rect.left;
    if (window.innerHeight < 350 || window.innerWidth < 991) { // mobile should wait sidebar buttons height set
      top = Math.round(((rect.top - ((80 - rect.width) / 2)) * 100)/100);
      left = Math.round(((rect.left - ((80 - rect.height) / 2)) * 100)/100);
    }
    nodes.ring.css("transform", "translate("+left+"px, "+top+"px)");
  };

  this.resizeLines = function () {
    _this.exitTutorial(false);
    //Menu.hideSidebarSide();
    store.dispatch(setSQFTMenuOpened(""));
    store.dispatch(setSQFTActiveButton(""));
    const shapes = Workspace.getShapes();
    if (shapes.length) {
      // Workspace.setAllowEdges(true);
      // Workspace.setAllowLineHighlight(true);

      config.highlight.lines = true;  // enable lines highligh// ting
      config.highlight.tutorial = true;  // enable lines highlighting

      const counterTopShape = shapes.find(shape => shape.partId === "countertop") || shapes[0];
      const shapeLines = counterTopShape.getLines();
      switch (window.setNextLayout) {
        case "S":
        case "SP":
        case "SI":
        case "SPI": {
          const verticalLine = shapeLines[shapeLines.length - 1];
          _this.resizeVerticalLine(verticalLine, false, () => {
            _this.resizeVerticalLineBack(verticalLine, true);
          });
          break;
        }
        case "SN":
        case "SPN":
        case "SNI":
        case "SPNI": {
          const horizontalLine = shapeLines[2];
          _this.resizeHorizontalLine(horizontalLine, true, () => {
            _this.resizeHorizontalLineBack(horizontalLine, false);
          });
          const verticalLine = shapeLines[shapeLines.length - 1];
          _this.resizeVerticalLine(verticalLine, false, () => {
            _this.resizeVerticalLineBack(verticalLine, true, horizontalLine);
          });
          break;
        }
        case "L":
        case "LI": {
          const verticalLine = shapeLines[1];
          _this.resizeVerticalLine(verticalLine, true, () => {
            _this.resizeVerticalLineBack(verticalLine, false);
          });
          break;
        }
        case "LN":
        case "LNI": {
          const verticalLine = shapeLines[shapeLines.length - 1];
          _this.resizeVerticalLine(verticalLine, false, () => {
            _this.resizeVerticalLineBack(verticalLine, true);
          });
          const horizontalLine = shapeLines[2];
          _this.resizeHorizontalLine(horizontalLine, true, () => {
            _this.resizeHorizontalLineBack(horizontalLine, false);
          });
          break;
        }
        default:
          break;
      }
    }
  };

  this.resizeVerticalLine = function (verticalLine, toTheRight, callback) {
    verticalLine.highLightedByTutorial = true;
    verticalLine.setTutotialImage(nodes.tutorialImages.horizontal);
    let xDiff = 1;
    const basicX = verticalLine.from.x;
    _this.timer = setTimeout(function run() {
      verticalLine.from.x = toTheRight ? basicX + xDiff : basicX - xDiff;
      verticalLine.to.x = verticalLine.from.x;
      xDiff++;
      if (xDiff === 20) {
        callback();
      } else {
        setTimeout(run, 40);
      }
    }, 0);
  };

  this.resizeVerticalLineBack = function (verticalLine, toTheRight, horizontalLine) {
    _this.resizeVerticalLine(verticalLine, toTheRight, () => {
      if (resizeTimes === 2) {
        _this.stopResize(verticalLine, horizontalLine);
      } else {
        resizeTimes++;
        _this.resizeLines();
      }
    });
  };

  this.resizeHorizontalLine = function (horizontalLine, toTheBottom, callback) {
    horizontalLine.highLightedByTutorial = true;
    horizontalLine.setTutotialImage(nodes.tutorialImages.vertical);
    let yDiff = 1;
    const basicY = horizontalLine.from.y;
    _this.timer2 = setTimeout(function run() {
      horizontalLine.from.y = toTheBottom ? basicY + yDiff : basicY - yDiff;
      horizontalLine.to.y = horizontalLine.from.y;
      yDiff++;
      if (yDiff === 20) {
        callback ? callback() : null;
      } else {
        setTimeout(run, 40);
      }
    }, 0);
  };

  this.resizeHorizontalLineBack = function (horizontalLine, toTheRight) {
    _this.resizeHorizontalLine(horizontalLine, toTheRight);
  };

  this.stopResize = function (verticalLine, horizontalLine) {
    // console.log("STOP!");
    clearTimeout(_this.timer);
    clearTimeout(_this.timer2);
    if (verticalLine) {
      verticalLine.highLightedByTutorial = false;
      verticalLine.setTutotialImage(null);
    }
    if (horizontalLine) {
      horizontalLine.highLightedByTutorial = false;
      horizontalLine.setTutotialImage(null);
    }
    // Workspace.setAllowEdges(false);
    // Workspace.setAllowLineHighlight(false);
    config.highlight.lines = false;  // enable lines highlighting
    config.highlight.tutorial = false;  // enable lines highlighting
    //Menu.openMenu();
    store.dispatch(setSQFTMenuOpened("move"));
    store.dispatch(setSQFTActiveButton("move"));
    setTimeout(() => {
      _this.showTutorial(function () {
        _this.showNextStep(true);
      });
    }, 300);
  };

  this.edgeClick = function () {
    const edgesButtonsArray = [].slice.call(document.querySelectorAll("#edge-overlay-items .lightbox-option-round"));
    const shapes = Workspace.getShapes();
    if (edgesButtonsArray.length && shapes.length) {
      _this.exitTutorial(false);
      store.dispatch(setSQFTMenuOpened("edge"));
      store.dispatch(setSQFTActiveButton("edge"));
      //Menu.navButtonClick(document.querySelector(".navigation .button[data-open=\"edge\"]"));
      setTimeout(() => {
        const edgeButton = edgesButtonsArray[5] || edgesButtonsArray[0];
        $(edgeButton).trigger("click");
        setTimeout(() => {
          //Menu.hideSideBarContent();
          store.dispatch(setSQFTMenuOpened(""));
          store.dispatch(setSQFTActiveButton(""));
          const counterTopShape = shapes.find(shape => shape.partId === "countertop") || shapes[0];
          const shapeLines = counterTopShape.getLines();
          let chapeCount = shapeLines.length - 1;
          _this.timer = setTimeout(function run() {
            const line = shapeLines[chapeCount];
            let excludedLines = [];
            switch (window.setNextLayout) {
              case "S":
              case "SP":
              case "SI":
              case "SPI":
                excludedLines = [0];
                break;
              case "SN":
              case "SPN":
              case "SNI":
              case "SPNI":
                excludedLines = [0, 1];
                break;
              case "L":
              case "LI":
                excludedLines = [0, 5];
                break;
              case "LN":
              case "LNI":
                excludedLines = [0, 1, 7];
                break;
              default:
                break;
            }
            if (!excludedLines.includes(chapeCount)) {
              var attachedTo = Workspace.getImagesAttachedTo(line);
              if (attachedTo) {
                Workspace.removeShape(attachedTo);
              }

              line.addEdgeToLine($(edgeButton).attr('data-shared-feature-name'), $(edgeButton).attr('data-id'));
              line.setTutotialImage(nodes.tutorialImages.edgeImageButton);
            }
            chapeCount--;
            if (!chapeCount) { // chapeCount === 0
              clearTimeout(_this.timer);
              store.dispatch(setSQFTMenuOpened("move"));
              store.dispatch(setSQFTActiveButton("move"));

              sqftEventManager.resetCursor(window);
              sqftEventManager.removeEvent(window);
              // Menu.navButtonClick(document.querySelector(".navigation .button[data-set=\"move\"]")); // close edge
              _this.showTutorial(function () {
                _this.showNextStep(true);
              });
            } else {
              setTimeout(run, 500);
            }
          }, 0);
        }, 900);
      }, 600);
    } else {
      _this.showNextStep(true);
    }
    // _this.showNextStep();
  };

  function addImageToBody(src, nodeKey, size) {
    const img = document.createElement("img");
    img.crossOrigin = "Anonymous";
    const $img = $(img);
    $img.css({
      position: "absolute",
      width: "1px",
      height: "1px"
    });
    $img.appendTo($("body"));
    $img.attr("src", src);
    $img.attr("data-size", size);
    nodes.tutorialImages[nodeKey] = img;
  }

  this.addCursorImages = function () {
    addImageToBody(objectFlipVertical, "horizontal", 32);
    addImageToBody(objectFlipHorizontal, "vertical", 32);
    addImageToBody(iconGreenPlus32, "edgeImageButton", 32);
  };

  this.removeCursorImages = function () {
    Object.keys(nodes.tutorialImages).forEach(key => {
      const image = nodes.tutorialImages[key];
      $(image).remove();
    })
  };

};
